import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Blockquote from '../../components/Blockquote';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import GenericCard from '../../components/GenericCards';
import profiles from '../../data/profiles/profiles.json';
import {
  PensionIndexProvider,
  PensionIndexStore,
} from '../../providers/pensionIndex';
import {
  ACCOUNT_ACTIVITY_ROUTE,
  PENSION_PROFILE_ROUTE,
} from '../../routes/types';
import { formatPrice } from '../../utils/utils';
import PopoverWithLinks from '../widgets/PopoverLinks/PopoverLinks';

const linksData = [
  {
    linkHeader: 'Account History',
    route: ACCOUNT_ACTIVITY_ROUTE,
  },

  {
    linkHeader: 'Pension Profile',
    route: PENSION_PROFILE_ROUTE,
  },
];

const accruedPensionData = [
  {
    title: 'Cash Balance Plan',
    balance: 53185.62,
    benefit: 355.21,
    payAge: 65,
  },

  {
    title: 'Qualified Plan',
    balance: 'n/a',
    benefit: 2643.98,
    payAge: 65,
  },

  {
    title: 'Non-Qualified Plan',
    balance: 'n/a',
    benefit: 602.95,
    payAge: 65,
  },
];

const DbInactiveDashboardView = () => {
  const { fingertipLinks, companiesMessages } =
    useContext(PensionIndexStore) || {};

  let date = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">
                Welcome, {profiles.data[0]['firstName']}!
              </div>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row className="text-sm-12-lg-14 p-0">
                  <Col className=" text-nowrap col-12 fw-light">
                    There are currently no events.
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>
      <Row className="m-0">
        <Col className="p-0 pe-lg-5 col-lg-7">
          <Row>
            <Col className="mt-12 mt-lg-8 pt-lg-3 col-12 d-flex justify-content-between">
              <h4 className="text-sm-20-lg-32">Current Accrued Pension</h4>
              <div className="d-flex ">
                <PopoverWithLinks linksData={linksData} />
              </div>
            </Col>
          </Row>
          <Row className="mt-6 mt-lg-10">
            <Col className="accrued-pension">
              <GenericCard variant="white">
                <Row className="px-6 px-lg-0 mb-5">
                  <Row className="px-0 mx-0 mb-3">
                    <Col className="col-6 px-0 "></Col>
                    <Col className="px-0 text-sm-12-lg-14 fw-light text-ligther-grey">
                      Balance
                    </Col>
                    <Col className="col-1 px-0 text-center text-sm-12-lg-14 text-gray-500">
                      OR
                    </Col>
                    <Col className="px-0 text-end text-sm-12-lg-14 fw-light text-ligther-grey">
                      Monthly Benefit
                    </Col>
                  </Row>
                  {accruedPensionData.map(
                    ({ title, balance, benefit, payAge }, index) => (
                      <Row
                        key={index}
                        className={`${
                          accruedPensionData.length !== index + 1
                            ? 'border-bottom'
                            : ''
                        } p-0 m-0`}
                      >
                        <Col className="col-6">
                          <Row className="my-5 text-indigo text-sm-14-lg-16">
                            {title}
                          </Row>
                          <Row className="mb-3 text-dark-gray-50 text-sm-12-lg-14 fw-light">
                            As of {date}
                          </Row>
                        </Col>
                        <Col
                          className={`${
                            index === 0 ? 'text-dark-gray fw-normal' : ''
                          } px-0 my-5 text-sm-14-lg-20 fw-light text-light-grey-normal`}
                        >
                          {typeof balance === 'number'
                            ? `${formatPrice(Number(balance), 'en-US', {
                                currency: 'USD',
                                style: 'currency',
                                minimumFractionDigits: 0,
                              })}`
                            : balance}
                        </Col>
                        <Col className="col-1 px-0"></Col>
                        <Col className="px-0 text-end">
                          <Col className="my-5 col-12 text-sm-16-lg-20">
                            {typeof benefit === 'number'
                              ? `${formatPrice(Number(benefit), 'en-US', {
                                  currency: 'USD',
                                  style: 'currency',
                                  minimumFractionDigits: 0,
                                })}`
                              : benefit}
                          </Col>
                          <Col className="mb-3 col-12 text-dark-gray-50 text-sm-12-lg-14 fw-light">
                            Pay Age {payAge}
                          </Col>
                        </Col>
                      </Row>
                    )
                  )}
                </Row>
                <Row className="px-6 px-lg-0 ">
                  <Blockquote variant="primary">
                    <div className="fw-bold ">Did You know?</div>
                    <div>
                      If you don't make an election and you die the remaining
                      payment will be made first to your designated beneficiary
                      and if your beneficiary is dead then to your Estate.
                    </div>
                  </Blockquote>
                </Row>
              </GenericCard>
            </Col>
          </Row>
        </Col>
        <Col className="pe-lg-0 mt-12 mt-lg-8 pt-lg-3 col-12 col-lg-5">
          <FingerTipsLinks data={fingertipLinks} />
        </Col>
      </Row>

      <Row className="mt-13">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

function DbInactiveDashboard() {
  return (
    <PensionIndexProvider>
      <DbInactiveDashboardView />
    </PensionIndexProvider>
  );
}

export default DbInactiveDashboard;
